import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpWalletQrisPaymentCollectionResponse } from '../../../data/repository/fs-wallet-qris/http-fs-wallet-qris.collection';
import { UseCase } from '../../base/usecase';
import { FSWalletQrisRepository } from '../../repository/fs-wallet-qris.repository';
import { QrisPaymentDTO } from './interface/qris-payment.dto';

@Injectable({
  providedIn: 'root',
})
export class QrisPaymentUsecase
  implements
    UseCase<QrisPaymentDTO, HttpWalletQrisPaymentCollectionResponse>
{
  constructor(private readonly repository: FSWalletQrisRepository) {}

  execute(
    data: QrisPaymentDTO
  ): Observable<HttpWalletQrisPaymentCollectionResponse> {
    return this.repository.QrisPayment(data);
  }
}
